import type { ApiOrgId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  optionsForPosting: ('JOB' | 'INTERNSHIP' | 'VOLOP' | 'EVENT')[];
};

function mapResponse(data: ApiResponse) {
  return data.optionsForPosting;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId) =>
    `/data/orgdashboard/${orgId}/options-for-posting`,
  mapResponse,
});

// Exports

export const orgDashboardApiIsomorphicFetchOptionsForPosting =
  endpoint.createIsomorphicFetchFn();
